import { __assign } from "tslib";
import * as React from 'react';
import cn from 'classnames';
import { useTheme } from '../../../../theme';
import SwitchComponent from '../../../../Switch';
var Switch = function (props) {
    var theme = useTheme('PassengerForm').Switch;
    return (React.createElement(SwitchComponent, __assign({ mainClassName: cn(theme.toggle, props.className), activeClassName: theme.toggle_active, labelClassName: theme.switch__label }, props)));
};
export default Switch;
